import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurableEditorSettingRemoteDto } from '../../../../../../generated/swagger';
import _ from 'lodash';

@Pipe({
   name: 'selectorValuesConverter',
})
export class SelectorValuesConverterPipe implements PipeTransform {
   transform(editorSettings: ConfigurableEditorSettingRemoteDto): string[] {
      return _.split(editorSettings.selectorValues, ',').map((v) => v.trim());
   }
}
